<template>
  <el-dialog
    title="Thông tin thẻ"
    :visible.sync="dialogCardCheckVisible"
    :close-on-click-modal="false"
    width="60%"
    append-to-body
    @close="() => {}"
  >
    <div class="das-form-container datnt">
      <div class="das-form-group">
        <div class="das-form-group-title">
          {{ 'Thông tin chung' }}
        </div>
        <InfoList
          :columns="3"
          :column-breakpoint-options="{
            sm: 1,
            md: 3
          }"
        >
          <InfoListLabel style="max-width: 300px">Số thẻ</InfoListLabel>

          <InfoListValue style="max-width: 300px">{{ data }}</InfoListValue>
        </InfoList>
      </div>

      <div class="das-form-group">
        <div class="das-form-group-title">
          {{ 'Danh sách phòng' }}
        </div>

        <div
          v-loading="loading"
          style="height: calc(34px * 5 + 40px)"
          class="grid-scroll"
        >
          <GridVx
            ref="agGrid"
            :columns="columns"
            :rows="rows"
            dom-layout="scroll"
            :auto-size-cell="true"
            class="agGrid"
          />
          <!-- :is-row-selectable="params => params.data?.sub_booking_group_id" -->
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogCardCheckVisible = false"
        >
          {{ 'Đóng' }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
import InfoListValue from '@/components/info-list/InfoListValue.vue'

import { getCardRoomByCardNumber } from '@/api/reception/card_service'

export default {
  components: {
    InfoListLabel,
    InfoListValue
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: String
    }
  },
  data() {
    return {
      rows: [],
      columns: [
        { headerName: 'Số phòng', field: 'room_num' },
        { headerName: 'Hạng phòng', field: 'room_level_nm' },
        { headerName: 'Khách sạn', field: 'hotel_nm' },
        { headerName: 'Ngày bắt đầu', field: 'start_date' },
        { headerName: 'Ngày hết hạn', field: 'end_date' },
        { headerName: 'Ngày tạo thẻ', field: 'create_date' },
        { headerName: 'Người tạo thẻ', field: 'create_user_nm' }
      ],
      loading: false
    }
  },
  computed: {
    dialogCardCheckVisible: {
      get() {
        // if (this.value) {
        //   this.$nextTick(() => {
        //     // Focus on the input using its ref
        //     this.$refs.hidden_id_card_inp.focus()
        //   })
        // }
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    data(nv, ov) {
      if (nv) {
        this.fnGetCardRoomByCardNumber(nv)
      }
    }
  },

  methods: {
    // handle api call
    fnGetCardRoomByCardNumber(cardNum) {
      this.loading = true
      getCardRoomByCardNumber(cardNum)
        .then(res => {
          if (!res.is_error) {
            this.rows = res.data
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.das-form-container.datnt > * + * {
  margin: 1rem 0;
}
</style>
